import React, { forwardRef, useEffect, useMemo } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { useChartTooltipsEnabled } from '../../hooks/useChartTooltipsEnabled';
import { applyChartTooltipForViewport } from '../../utils/chartTooltipViewport';

/**
 * HighchartsReact wrapper that disables chart tooltips on mobile/tablet (≤1024px).
 */
const ResponsiveHighchartsReact = forwardRef(function ResponsiveHighchartsReact(
  { options, immutable = false, ...rest },
  ref
) {
  const tooltipsEnabled = useChartTooltipsEnabled();

  const mergedOptions = useMemo(
    () => applyChartTooltipForViewport(options, tooltipsEnabled),
    [options, tooltipsEnabled]
  );

  useEffect(() => {
    const chart = ref?.current?.chart;
    if (!chart || chart.destroyed) return;
    chart.update({ tooltip: { enabled: tooltipsEnabled } }, false);
  }, [tooltipsEnabled, ref]);

  return (
    <HighchartsReact
      ref={ref}
      options={mergedOptions}
      immutable={immutable}
      {...rest}
    />
  );
});

export default ResponsiveHighchartsReact;
